jQuery(document).ready(function($) {

    function getUrlParameter(name) {
        var url = window.location.href;
        name = name.replace(/[[]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var search_query = getUrlParameter('s');
    $(document).on('click', '.load-more-btn', function() {
        var button = $(this);
        var paged = button.data('paged');
        var post_type = button.data('type');
        var nonce = button.data('nonce');

        // Make the AJAX request
        $.ajax({
            url: script_object.ajax_url,
            type: 'POST',
            data: {
                action: 'load_more_search',
                paged: paged,
                type: post_type,
                nonce: nonce,
                search: search_query
            },
            success: function(response) {
                if (response) {
                    $('#type-' + post_type).find('.posts').append(response.data.content);
                    button.data('paged', paged + 1);
                    if (response.data.query == paged + 1) {
                        button.hide();
                    }
                }
            }
        });
    });
});